
const recover = {
  step: 0,
  isLoading: false,
  isTemporal: false,
  validationCode: '',
  userInfoError: false,
  codeError: false,
  disableNext: true,
  email: '',
  phone: '',
  typeSelected: '',
};

export default recover;

